export default "__VITE_ASSET__yMw9QR7n__"